import { config } from '../_config';
import { authHeader, handleResponse } from '../_helpers';

export const phoneService = {
  createUserPhone,
  updateUserPhone,
  deleteUserPhone,
  getUserPhones
}

function createUserPhone(objPhone) {

  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader()
    },
    body: JSON.stringify(objPhone)
  };

  return fetch(`${config.apiUrl}/phones`, requestOptions).then(handleResponse);

}

function updateUserPhone(objPhone) {
console.log(objPhone)
  const requestOptions = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader()
    },
    body: JSON.stringify(objPhone)
  };

  return fetch(`${config.apiUrl}/phones/${objPhone.id}`, requestOptions).then(handleResponse);

}

function deleteUserPhone(idPhone) {

  const requestOptions = {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader()
    }   
  };

  return fetch(`${config.apiUrl}/phones/${idPhone}`, requestOptions).then(handleResponse);

}

function getUserPhones($userId) {

  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader()
    }   
  };

  return fetch(`${config.apiUrl}/phones/user/${userId}`, requestOptions).then(handleResponse);

}